import React from 'react';

import {Colors, MediaQuery, Text} from '@optimaxdev/design-system';
import {useSelector} from 'react-redux';

import {useMediaQuery} from 'react-responsive';

import {getOrderDetails} from '../../../selectorsV2';

import {getTitleContent} from './helper';
import {usePrescriptionStatus} from './usePrescriptionStatus';

import s from './successHeader.scss';

/**
 * Header component for TYP CL
 */
export const SuccessHeader = () => {
    const isSmallScreen = useMediaQuery(MediaQuery.sm);

    const orderItems = useSelector(getOrderDetails);
    const status = usePrescriptionStatus();

    const {shipping_address: shippingAddress} = orderItems;

    const headerContent = getTitleContent(status, shippingAddress?.firstname);

    return (
        <>
            <div className={s.title}>
                <Text
                    color={Colors.blueCharcoal}
                    lineHeight={isSmallScreen ? '34px' : '38px'}
                    size={isSmallScreen ? '24px' : '28px'}
                    bold
                >
                    {headerContent.heading}
                </Text>
                <Text color={Colors.limedSpruce} lineHeight="24px" size="16px">
                    {headerContent.info}
                </Text>
            </div>
        </>
    );
};
